import { render, staticRenderFns } from "./OsakaRirekishoEdit.vue?vue&type=template&id=67bf23e0&scoped=true&"
import script from "./OsakaRirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./OsakaRirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./OsakaRirekishoEdit.vue?vue&type=style&index=0&id=67bf23e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf23e0",
  null
  
)

export default component.exports